import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRegelLeverancierSimple } from './regel-details.service';

@Injectable({
  providedIn: 'root'
})
export class RegelsService {
  _baseUrl: string;

  constructor(private _httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._baseUrl = baseUrl;
  }

  getSupplierRequest(selectedEan?: number): Observable<ISupplierRequest> {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregel/getSupplierRequest';

    let param: any;
    if (selectedEan) {
      param = { 'forKwekerEan': selectedEan };
    }

    return this._httpClient.get<ISupplierRequest>(requestUrl, { params: param });
  }

  getOfferteExport(ids: string[]) {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregel/getexcelexport';

    return this._httpClient.post(requestUrl, ids);
  }

  patchStatus(item: IPreSalesRow): Observable<any> {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregelleverancier/updatestatus/' + item.id;

    return this._httpClient.patch(requestUrl, item);
  }

  update(item: IPreSalesRow): Observable<any> {
    const requestUrl = this._baseUrl + 'api/offerteaanvraagregelleverancier/updateoverviewvalues/' + item.id;

    return this._httpClient.put(requestUrl, item);
  }
}

export enum LeverancierStatus {
  Nieuw = 0,
  Voltooid = 1,
  NietLeverbaarUitverkocht = 2,
  BeterAlternatief = 6
}

export enum LeverancierStatusString {
  'Nieuw' = 0,
  'Voltooid' = 1,
  'Niet Leverbaar/Uitverkocht' = 2,
  'Beter alternatief' = 6,
}

export interface ISupplierRequest {
  items: IPreSalesRow[];
  totalCount: number;
}

export interface IPreSalesRow {
  omschrijving: string;
  supplierAssignedId: number;
  id: string;
  sourceId: number;
  regelNr: number;
  status: LeverancierStatus;
  thumbnail: string;
  artikelNr: string;
  productNaam: string;
  potmaat?: number;
  hoogte?: number;
  vbnHoogte?: string;
  periodeVanJaar: number;
  periodeVanWeekNr: number;
  periodeTotJaar: number;
  periodeTotWeekNr: number;
  aantalGevraagd?: number;
  inkoperNaam: string;
  opmerkingInkoop: string;
  aantallenInAanvraagType: string;
  confirmationDate?: Date;
  createdDate: Date;
  modifiedDate?: Date;
  isChanged: boolean;
  debiteurNaam: string;
  deadlineInkoopDate: string;
  deadlineLeverancierDate: string;
  leverancierDetails?: IRegelLeverancierSimple;
}
